import { cn } from '@/src/helpers';
import { FC, HTMLAttributes } from 'react';
import { pageClasses } from '../page.constants';

type PageBodyProps = HTMLAttributes<HTMLDivElement>;

export const PageBody: FC<PageBodyProps> = ({ className, children, ...rest }) => (
  <div className={cn(pageClasses.body, className, 'flex-1 overflow-y-auto p-2')} {...rest}>
    {children}
  </div>
);
